// opervex-frontend/src/components/DynamicReport.js

import React, { useState } from "react";
import DynamicTable from "./DynamicTable";
import LayoutConfigMenu from "./LayoutConfigMenu";
import FilterDialog from "./FilterDialog";
import ExportData from "./ExportData";

const DynamicReport = ({ reportName, urlData, links, schema }) => {
  const [dados, setDados] = useState([]);
  const [layout, setLayout] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  return (
    <>
      <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
        {/* Dialog de Filtros */}
        <FilterDialog layout={layout || []} setData={setDados} urlData={urlData} setPage={setPage} />

        {/* Export Excel*/}
        <ExportData data={dados} filename={reportName} />

        {/* Configuração de Layout */}
        <LayoutConfigMenu
          layout={layout || []}
          setLayout={setLayout}
          reportName={reportName}
          schema={schema}
          onLayoutSelected={setSelectedLayout}
        />

        <span className="badge bg-light text-dark border fs-6 fw-normal">
          Layout — {selectedLayout?.text || selectedLayout?.variant || "Padrão"}
          {selectedLayout?.text && selectedLayout?.variant ? ` (${selectedLayout.variant})` : ""}
        </span>
      </div>

      {/* Tabela Dinâmica */}
      <DynamicTable
        layout={layout || []}
        dados={dados || []}
        page={page}
        links={links || []}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
      />
    </>
  );
};

export default DynamicReport;
